import { createComponent } from '@mtfe/sweet';
import { eventBus, common, createDeepLink, createObserve } from '@mtfe/sweet-utils';
import { Draw, CouponListC, componentUtils } from '@mtfe/sweet-components';
import tpl from './dom.html';
import style from './style.less';
import store from '../../store/index';
import InnerPoi from '../common/InnerPoi/script';
import { COUPON_STATUS } from '../../constants/index';
import { fetchAllCoupon } from '../../utils/fetchData';
import { filterNewCoupon } from '../../utils/filter';
import { renderPoiInfoG } from '../../utils/renderPoi';
import { useAutoLogin } from '../../utils/index';
import http from '../../service';

const { storeCommon } = store;

const { debounceByPromise, createUniqueId } = common;
const { getOnClickEventName } = componentUtils;

const listUniqueId = createUniqueId();
const wmEveryDayId = createUniqueId();
const deepLink = createDeepLink();

const couponListMonitor = (currentListUniqueId) => {
    const { structInfo } = storeCommon;
    const { dom_wm_every_day_coupon: domWmEveryDayCoupon } = structInfo.struct;
    const storeWmEveryDayCoupon = store[domWmEveryDayCoupon.recallBizId];

    const couponDomList = Array.from(document.querySelectorAll(`#${currentListUniqueId} [coupon-monitor-index]`));
    const observeCb = async (err, item) => {
        if (err) {
            return;
        }
        const componentID = CouponListC.describe.getComponentID();
        try {
            const currentIndex = item.target.getAttribute('coupon-monitor-index');
            const currentCouponList = storeWmEveryDayCoupon.discountData.couponList;
            const url = `${currentCouponList[currentIndex].impMonitorUrl}&componentId=${componentID}`;
            await http.gMonitorApi(url);
        } catch (error) {
            console.error('曝光失败', error);
        }
    };
    if (couponDomList.length) {
        createObserve(observeCb, couponDomList);
    }
};

const EveryDayComponentReady = () => {
    eventBus.$on('EveryDayComponentReady', () => {
        couponListMonitor(listUniqueId);
        const { dom_wm_every_day_coupon: domWmEveryDayCoupon } = storeCommon.structInfo.struct;
        // 触发对Draw中商家列表的曝光监控
        eventBus.$emit(getOnClickEventName(domWmEveryDayCoupon.recallBizId));
    });
};

/**
 * CouponListC组件
 * @param {*} discountData
 * @param {*} welfareIndex
 * @param {*} couponListDraw
 * @returns
 */
const initCouponListC = (discountData, welfareIndex, couponListDraw) => {
    const { couponList = [], recallBizId, giftValue } = discountData;

    const onBatchRecvClickHandler = debounceByPromise(
        useAutoLogin(async () => {
            // 这个数组必须定义在领券之前
            const newCouponPoiList = filterNewCoupon(couponList);
            try {
                await fetchAllCoupon(couponList, recallBizId);
                const couponListContainer = document.getElementById(wmEveryDayId);
                if (couponListContainer) {
                    couponListContainer.innerHTML = initCouponListC(discountData, welfareIndex, couponListDraw);
                }
            } catch (error) {
                console.error(error);
            }
            // 领券之后，带参数上报商家的点击
            // 领券失败也要上报
            const componentID = CouponListC.describe.getSubComponent('ReceiveAll').getComponentID();
            newCouponPoiList.forEach((poiInfoOfNewCouponList) => {
                const url = `${poiInfoOfNewCouponList.clickMonitorUrl}&componentId=${componentID}`;
                http.actGeClkM(url);
            });
        }),
        500,
    );
    const onCouponClickHandler = debounceByPromise(
        useAutoLogin(async (poiInfo) => {
            const { giftInfo } = poiInfo;
            if (giftInfo && giftInfo.status === COUPON_STATUS.STATUS_NEW) {
                // 这个数组必须定义在领券之前
                const newCouponPoiList = filterNewCoupon(couponList);
                try {
                    await fetchAllCoupon(couponList, recallBizId);
                    const couponListContainer = document.getElementById(wmEveryDayId);
                    if (couponListContainer) {
                        couponListContainer.innerHTML = initCouponListC(discountData, welfareIndex, couponListDraw);
                    }
                } catch (error) {
                    console.error(error);
                }

                // 领券之后，带参数上报商家的点击
                // 领券失败也要上报
                const componentID = CouponListC.describe.getSubComponent('ReceiveAll').getComponentID();
                newCouponPoiList.forEach((poiInfoOfNewCouponList) => {
                    const url = `${poiInfoOfNewCouponList.clickMonitorUrl}&componentId=${componentID}`;
                    http.actGeClkM(url);
                });
            }
            const componentID = CouponListC.describe.getSubComponent('Coupon').getComponentID();
            const url = `${poiInfo.clickMonitorUrl}&componentId=${componentID}`;

            // 此处不再需要单独上报
            deepLink.gotoDp(poiInfo.dpUrl, poiInfo.lpUrl, () => {
                http.actGeClkM(url);
            });
        }),
        500,
    );

    return CouponListC({
        giftInfoList: couponList,
        welfareIndex,
        title: `${giftValue / 100}元超值券包`,
        onCouponClick: onCouponClickHandler,
        onBatchRecvClick: onBatchRecvClickHandler,
        onBatchUseClick: () => {
            couponListDraw.onOpenDraw();
        },
        listUniqueId,
    });
};

const EveryDayComponent = (welfareIndex) => {
    const { dom_wm_every_day_coupon: domWmEveryDayCoupon } = storeCommon.structInfo.struct;
    const storeWmEveryDayCoupon = store[domWmEveryDayCoupon.recallBizId];
    const { discountData, poiData } = storeWmEveryDayCoupon;
    const couponListDraw = new Draw(
        InnerPoi({
            poiData,
            isOpenAutoLoading: false,
            renderFunc: renderPoiInfoG,
        }),
    );
    const data = {
        wmEveryDayId,
        wmEveryDayDom: initCouponListC(discountData, welfareIndex, couponListDraw),
        couponListDraw: couponListDraw.getComponent(),
    };
    const events = {};
    EveryDayComponentReady();
    return createComponent(tpl, { data, style }, events);
};

export default EveryDayComponent;
